import { cva } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '../../styles/lib/utils';

const projectTypeButtonVariants = cva('flex cursor-pointer flex-col rounded border p-3 py-2 text-left focus-ring');

type ProjectTypeButtonProps = Omit<React.ComponentProps<'button'>, 'type'> & {
  label: React.ReactNode;
  description: React.ReactNode;
};

function ProjectTypeButton({ label, description, className, ...props }: ProjectTypeButtonProps) {
  return (
    <button
      type="button"
      data-slot="project-type-button"
      className={cn(projectTypeButtonVariants(), className)}
      {...props}
    >
      <span className="block font-semibold">{label}</span>
      <span className="block text-xs text-secondary">{description}</span>
    </button>
  );
}

export { ProjectTypeButton, projectTypeButtonVariants };
export type { ProjectTypeButtonProps };
